export const isUsableConnectionString = (value: string | undefined): value is string => {
  if (!value) {
    return false;
  }

  const normalized = value.trim();

  if (!normalized || normalized.includes('$(')) {
    return false;
  }

  return normalized.includes('InstrumentationKey=') || normalized.includes('IngestionEndpoint=');
};
